import { render, staticRenderFns } from "./EntranceStudentPage.vue?vue&type=template&id=d38ef266&scoped=true&"
import script from "./EntranceStudentPage.vue?vue&type=script&lang=ts&"
export * from "./EntranceStudentPage.vue?vue&type=script&lang=ts&"
import style0 from "./EntranceStudentPage.vue?vue&type=style&index=0&id=d38ef266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38ef266",
  null
  
)

export default component.exports